<template>
  <div>
    <wysiwyg-editor :model="note" @change="val => note = val" :light='true' :tooltip-top="true"
                    :fromQuickview="true" class="is-padding-xsmall wysiwygEditor--noteLeads"></wysiwyg-editor>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'NewNote',
    data () {
      return {
        note: null
      }
    },
    props: {
      source: {
        type: Object,
        required: false
      }
    },
    computed: {
      ...mapGetters(['currentUserPk', 'currentUserName'])
    },
    methods: {
      submit () {
        this.$emit('submit', this.note)
      },
      openWysiwyg () {
        this.openWysi = true
        this.$nextTick(() => {
          let wysiElem
          if (this.source) {
            let selection = document.getSelection()
            let range = document.createRange()
            let contenteditable = document.querySelector('div[contenteditable="true"]')

            if (contenteditable.lastChild.nodeType === 3) {
              range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
            } else {
              range.setStart(contenteditable, contenteditable.childNodes.length)
            }
            selection.removeAllRanges()
            selection.addRange(range)
          } else {
            wysiElem = document.getElementsByClassName('ql-editor ql-blank')
            wysiElem = wysiElem[0]
            wysiElem.setAttribute('contenteditable', 'true')
            wysiElem.focus()
          }
        })
      },
      calculHeight () {}
    },
    created () {
      if (this.source) this.note = this.source.note
      this.openWysiwyg()
    },
    mounted () {
      // window.addEventListener('resize', this.calculHeight)
    },
    destroyed () {
      // window.removeEventListener('resize', this.calculHeight)
    }
  }
</script>


<style lang="sass">
.quickview
  .wysiwygEditor--noteLeads
    .ql-container
      .ql-editor
        // HB :
        // Fix manuel de la hauteur du champs de note
        // Tellement particulier quand me fait manuellement en css
        // On pourrait aussi le faire en JS mais lancer des calculs de hauteurs ne me semble pas pertinant
        // L'imbrication des sélecteurs est importante pour être sur de ne pas toucher l'élément sur d'autre page.
        min-height: 250px
        height: 51vh
        height: calc(100vh - 83px - 55px - 7px - 36px - 7px - 82px)
        max-height: 80vh
</style>


// WEBPACK FOOTER //
// src/components/quickview/NewNote.vue